import { getEditor, isEnabled, isEditorRTL } from '../composables/editorsMap';
import { hasNodeWithAttribute } from '../composables/utils';
import { IndentIncrease, IndentDecrease } from 'lucide-vue-next';

export const getIndentOptions = (id: string, isIncrease: boolean) => {
  const editor = getEditor(id)?.value;
  const isRTL = isEditorRTL(id);

  return {
    disabled: !isEnabled(id, 'indent'),
    icon:
      (isRTL && !isIncrease) || (!isRTL && isIncrease)
        ? IndentIncrease
        : IndentDecrease,
    title:
      (isRTL && isIncrease) || (!isRTL && isIncrease)
        ? 'הזחה קדימה'
        : 'הזחה אחורה',
    action: () =>
      editor.chain().focus()[isIncrease ? 'indent' : 'outdent']().run(),
    isActive: () => (isIncrease ? !!hasNodeWithAttribute(id, 'indent') : false),
  };
};
